import { Button } from "./Button";
import React from 'react';
import './Hero.css'
import '../App.css'

function Hero(){
    return (
        <div className = 'hero-container'>
            <video src = 'video1.mp4' 
            autoplay loop muted/>
            <p> Find the Perfect Styles for Your Hair Type! </p>
            <div className = "hero-btns">
              <Button 
              className = "btns" 
              buttonStyle = 'btn--primary'
              buttonsize = 'btn--large'> 
              WATCH HAIRLOVE <i className = 'far fa-play-circle'></i>
            </Button>
            </div>
            <h1> #ALLHAIRISGOODHAIR </h1>
            
            

        
    </div>
    )
}
export default Hero;